import React, { useState, useEffect } from "react";
import { CareRecipient } from "../../../../domain/care_recipient/CareRecipient";
import { PrimaryButton } from "../../disease_knowledge/components/PrimaryButton";
import styles from "./ElectricPowerAlertSetting.module.scss";
import { Loading } from "../../common/Loading";
import { SwitchButton } from "../../common/button/SwitchButton";
import { orderErrorToast, orderSuccessToast } from "../../../funcs/orderResultToast";
import { ApiRequest } from "../../../../state/api/ApiRequest";

export function ElectricPowerAlertSetting(props: Props) {

    const { careRecipient } = props;

    const [enabled, setEnabled] = useState(false);
    const [loading, setLoading] = useState(false);

    const onClickEnabled = () => {
        setEnabled(prev => !prev);
    };

    useEffect(() => {
        const getElectricPowerAlertSetting = async () => {
            setLoading(true);
            try {
                await ApiRequest.get(
                    `/api/alert-settings/electric-power/${careRecipient.id.value}`,
                    {},
                    (response: Response) => {
                        response.json().then(
                            data => {
                                setEnabled(data.enabled);
                            }
                        );
                    },
                    (response: Response) => {
                        if (response.status === 404) {
                            // 設定未登録の場合はデフォルト値を設定する
                            setEnabled(false);
                        } else {
                            orderErrorToast("電力アラート設定の取得に失敗しました");
                        }
                    },
                );
            } finally {
                setLoading(false);
            }
        };
        getElectricPowerAlertSetting();
    }, [careRecipient]);

    const onClick = () => {
        const requestBody = {
            enabled: enabled
        };
        ApiRequest.post(
            `/api/alert-settings/electric-power/${careRecipient.id.value}`,
            {},
            requestBody,
            () => { orderSuccessToast("電力アラート設定を更新しました"); },
            () => { orderErrorToast("電力アラート設定に失敗しました"); }

        );
    };

    return (
        <div className={styles.container}>
            {loading && <div className={styles.loading}><Loading /></div>}
            <h1 className={styles.title}>電力アラート設定</h1>
            <div className={styles.main}>
                <div className={styles.form}>
                    <div className={styles.label}>アラート有効化</div>
                    <div className={styles.toggleAlert}>
                        <SwitchButton switchOn={enabled} onClick={onClickEnabled}/>
                    </div>
                </div>
                <div className={styles.buttonArea}>
                    <PrimaryButton onClick={onClick}>
                        登録
                    </PrimaryButton>
                </div>
            </div>
        </div>
    );
}

type Props = {
    careRecipient: CareRecipient;
}

